// extracted by mini-css-extract-plugin
module.exports = {"Clickable":"Breadcrumb_Clickable__TozQr"};